// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"b4a8e8a7be063bf67cb4","751":"73fb3da35162bc46f84a","767":"00eb93a8e2cbccf65f16","3385":"9918b4e57aea0016a1fc","6027":"9a4326dd94c1f6e617b6","6977":"e4abfc271e6c65c96b91","8475":"64fe37203dfa3c891ad3"}[chunkId] + ".css";
};